
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';

import {
  Connection, CancelledConnection,
} from '@/types';
import UpdateButton from '@/components/UpdateButton.vue';
import CancelledConnectionDetailsIcon from './CancelledConnectionDetailsIcon.vue';

moment.locale('it');

@Component({
  components: {
    UpdateButton,
    CancelledConnectionDetailsIcon,
  },
})
export default class CancelledConnectionsDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false

  loading = false
  cancelledConnections: CancelledConnection[] = []

  // Questo componente necessita che la Lead a cui è associato l'allegato sia selezionata

  // La Connection selezionata
  get connection(): Connection | null {
    return this.$store.getters.currentConnection as Connection | null;
  }

  mDate(date: Date | null | undefined): string | null { return date ? moment(date).format('L') : null; }

  @Watch('value')
  async onValueChange(val: boolean) {
    this.dialog = val;
    console.log(`${this.constructor.name}: refresh()${this.dialog}`); // eslint-disable-line no-console
    // Se stiamo aprendo il dialog passa alla prima scheda
    if (val) {
      // Ricavo i dati
      this.loading = true;
      this.cancelledConnections = await this.$store.dispatch('getCancelledConnections', { id: this.connection?.id });
      this.loading = false;
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  onCancel() {
    this.dialog = false;
  }
}
